import { defineAsyncComponent } from 'vue'
export default {
  itinerario: defineAsyncComponent(() => import("/app/layouts/itinerario.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/app/layouts/main.vue").then(m => m.default || m))
}